import { gql } from '@apollo/client';

export const DELETE_CREDENTIALS_VTEX = gql`
  mutation DeleteVtexCredentials($storeId: ID!) {
    deleteVtexCredentials(storeId: $storeId) {
      ... on DeleteVtexCredentialsSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
